import { Component } from '@angular/core';

@Component({
  selector: 'app-MyClaims',
  templateUrl: './myclaims.component.html',
  styleUrl: './myclaims.component.scss'
})
export class MyClaimsComponent {

}
